import { render, staticRenderFns } from "./vendor-discount.vue?vue&type=template&id=38822ce4&"
import script from "./vendor-discount.vue?vue&type=script&lang=js&"
export * from "./vendor-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports